import {Bar} from "react-chartjs-2"
import React from "react";

function DashboardVerticalBar({data}) {

  return (
    <div>
      <Bar
        data={{
          labels: Object.keys(data),
          datasets: [
            {
              label: "Resultado",
              data: Object.values(data),
              backgroundColor: [
                'rgba(34,139,34,0.5)',
                'rgba(54, 162, 235,0.5)',
                'rgba(50,205,50,0.5)',
                'rgba(0,128,128, 0.5)',
                'rgba(131,111,255,0.5)',
              ],
              borderWidth: 2
            },
          ],
        }}
        height={400}
        width={600}
        options={
          {
            maintainAspectRatio: false,
            scales: {
              yAxes: [
                {
                  ticks: {
                    beginAtZero: true,
                  }
                },
              ]
            },
            legend: {
                labels: { fontColor: 'transparent', 
                boxWidth: 0,
            },
            },
            hover: {
              animationDuration: 1
            },
            animation: {
              duration: 1,
              onComplete: function () {
                var chartInstance = this.chart,
                  ctx = chartInstance.ctx;
                ctx.textAlign = 'center';
                ctx.fillStyle = "rgba(0, 0, 0, 1)";
                ctx.textBaseline = 'bottom';
                this.data.datasets.forEach(function (dataset, i) {
                  var meta = chartInstance.controller.getDatasetMeta(i);
                  meta.data.forEach(function (bar, index) {
                    var data = dataset.data[index];
                    ctx.fillText(data, bar._model.x, bar._model.y - 2);
                  });
                });
              }
            }
          }}
      />
    </div>
  )
}

export default DashboardVerticalBar


// WEBPACK FOOTER //
// ./src/component/Dashboard/DashboardVerticalBar.js